import React, { useEffect, useState } from 'react';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert, { AlertProps } from '@mui/material/Alert';
import Slide from '@mui/material/Slide';
import { useSnackbar } from '../../../hooks/shared/useSnackbar';

const Alert = React.forwardRef<HTMLDivElement, AlertProps>(
  function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  }
);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function SlideTransition(props: any) {
  return <Slide {...props} direction="up" />;
}

export const AppSnackbar: React.FC = () => {
  const { snackbarMessage, hideSnackbar } = useSnackbar();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (snackbarMessage) {
      setOpen(true);
    }
  }, [snackbarMessage]);

  const handleClose = (
    event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
    hideSnackbar();
  };

  return (
    <Snackbar
      open={open}
      autoHideDuration={3000}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      TransitionComponent={SlideTransition}
    >
      {snackbarMessage ? (
        <Alert onClose={handleClose} severity={snackbarMessage.severity}>
          {snackbarMessage.message}
        </Alert>
      ) : undefined}
    </Snackbar>
  );
};
